import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { AffectedTour } from './assign-sub-project-to-tour-controller-request.service';
import { Observable } from 'rxjs';
import { _post } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class AssignImmoTaskToTourControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: AssignImmoTaskRequest,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res: AssignImmoTaskResult) => {
    if (res != null && CollectionHelper.isPopulated(res.affectedTours)) {
      res.affectedTours.forEach((t) => this.processTour(t));
    }
    return res;
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/tours/assignImmoTask', requestServices);
  }

  public assignImmoTaskToTour(
    immoTaskId: number,
    placerId?: number,
    tourDate?: moment.Moment,
    locked?: boolean
  ): Promise<AssignImmoTaskResult> {
    const request: AssignImmoTaskRequest = {
      immoTaskId: immoTaskId,
      placerId: placerId,
      date: tourDate == null ? null : tourDate.format('YYYYMMDD'),
      locked: locked,
    };
    return this.post('', request, this.deserialize).toPromise();
  }

  private processTour(tour: AffectedTour): void {
    tour.date = tour.date == null ? null : DateHelper.parseDate(tour.date);
  }
}

interface AssignImmoTaskRequest {
  immoTaskId: number;
  placerId?: number;
  date?: string;
  locked?: boolean;
}

export interface AssignImmoTaskResult {
  affectedTours: AffectedTour[];
  tourItemId: number;
}
